import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponent } from './shared.component';
import { IonicModule } from '@ionic/angular';
import { FaqComponent } from './faq/faq.component';
import { VerificationComponent } from './verification/verification.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SuccessComponent } from './success/success.component';
import { VerificationLoginComponent } from './verification-login/verification-login.component';
import { ViewCmsContentComponent } from './view-cms-content/view-cms-content.component';
import { ListFilterPipe } from '../pipes/list-filter.pipe';
import { ErrorComponent } from './error/error.component';
import { environment } from 'src/environments/environment';
import { NgSelectModule } from '@ng-select/ng-select';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { DndDirective } from '../directives/dnd.directive';
import { AccountInfoComponent } from './account-info/account-info.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    NgOtpInputModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbDatepickerModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
    SharedComponent,
    FaqComponent,
    VerificationComponent,
    SuccessComponent,
    VerificationLoginComponent,
    ViewCmsContentComponent,
    ListFilterPipe,
    ErrorComponent,
    NavBarComponent,
    DndDirective,
    AccountInfoComponent,
  ],
  entryComponents: [
    FaqComponent,
    VerificationComponent,
    SuccessComponent,
    VerificationLoginComponent,
    ViewCmsContentComponent,
    ErrorComponent,
    NavBarComponent,
    AccountInfoComponent,
  ],
  exports: [
    FaqComponent,
    VerificationComponent,
    SuccessComponent,
    VerificationLoginComponent,
    ViewCmsContentComponent,
    ErrorComponent,
    NavBarComponent,
    DndDirective,
    AccountInfoComponent,
  ],
})
export class SharedModule { }
// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, environment.HOST + '/b2c/clearance-app/assets/i18n/', '.json');
}
